var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fieldset",
    { staticClass: "mt-3 col-12 d-flex flex-column filter-field-set" },
    _vm._l(_vm.options, function (ref, index) {
      var key = ref.key
      var itemValue = ref.value
      var name = ref.name
      return _c(
        "div",
        { key: index, staticClass: "pretty p-icon p-smooth mt-0 mb-3" },
        [
          _c("input", {
            staticClass: "form-check-input",
            attrs: { id: "filter-" + key + "-" + index, type: "checkbox" },
            domProps: { value: itemValue, checked: _vm.isSelected(itemValue) },
            on: {
              change: function ($event) {
                return _vm.handleChange($event, index)
              },
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "state p-primary" }, [
            _c("i", { staticClass: "icon fa fa-check" }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "clickable text-gray text-capitalize",
                attrs: { for: "filter-" + key + "-" + index },
              },
              [_vm._v(_vm._s(name))]
            ),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }